import { useEffect } from "react";
import { copy } from "../copy";
import { useLandingFeed } from "../feed";
import SiteFooter from "../components/SiteFooter";
import { useActivity, useGlobalStats, usePublicReviews } from "../websites/data";
import { Momentum, PlatformStats, ProducerEarnings, Reactions } from "../websites/DataSections";
import Pricing from "../websites/Pricing";
import {
  AudienceFilter,
  BeatStoreIntegration,
  BeforeAfter,
  CoSign,
  FinalCTA,
  Hero,
  InteractionHub,
  WhatYouGet,
} from "../websites/Sections";

// The producer-websites pitch. Every figure on it comes from the platform;
// a section with nothing to show does not render.
export default function Websites() {
  const stats = useGlobalStats();
  const feed = useLandingFeed();
  const activity = useActivity();
  const reviews = usePublicReviews();

  useEffect(() => {
    document.title = copy.websites.title;
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-ground font-sans text-chrome antialiased">
      <main>
        <Hero />
        <PlatformStats stats={stats} />
        <AudienceFilter />
        <BeforeAfter />
        <InteractionHub />
        <Reactions reviews={reviews} />
        <CoSign />
        <BeatStoreIntegration />
        <WhatYouGet />
        <ProducerEarnings winners={feed?.winnersWall ?? []} />
        <Momentum activity={activity} />
        <Pricing />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  );
}
